( function( $ ) {
    "use strict";

    var DEFAULT_DURATION = 75; // in minutes

    var _events = {
        onPeriodPickerRefresh: function(ev) {
            var $formEntry = $(this),
                $startDate = $formEntry.find('[data-form-control="start_date"]'),
                $startTime = $formEntry.find('[data-form-control="start_time"]'),
                $endDate = $formEntry.find('[data-form-control="end_date"]'),
                $endTime = $formEntry.find('[data-form-control="end_time"]');

            if (! ($startDate.val() && $startTime.val() && $endDate.val() && $endTime.val()) ||
                $formEntry.data('period-picker.state')
            ) {
                return;
            }

            $formEntry.data('period-picker.state', 'refresh');

            var startDate = $startDate.datepicker('getDate'),
                startTime = $startTime.timepicker('getTime'),
                endDate = $endDate.datepicker('getDate'),
                endTime = $endTime.timepicker('getTime'),
                realStartTime = new Date(
                    startDate.getFullYear(), startDate.getMonth(), startDate.getDate(),
                    startTime.getHours(), startTime.getMinutes(), startTime.getSeconds()
                ),
                realEndTime = new Date(
                    endDate.getFullYear(), endDate.getMonth(), endDate.getDate(),
                    endTime.getHours(), endTime.getMinutes(), endTime.getSeconds()
                );

            if (realEndTime.getTime() < realStartTime.getTime()) {
                var newEndDate = new Date(
                    startDate.getFullYear(), startDate.getMonth(), startDate.getDate(),
                    endTime.getHours(), endTime.getMinutes(), endTime.getSeconds()
                );

                if (newEndDate.getTime() >= realStartTime.getTime()) {
                    $endDate.datepicker('update', new Date(startDate.getTime()));
                } else {
                    var defaultDuration = $formEntry.data('period-duration') || DEFAULT_DURATION;

                    newEndDate = new Date(
                        new Date(
                            startDate.getFullYear(), startDate.getMonth(), startDate.getDate(),
                            startTime.getHours(), startTime.getMinutes(), startTime.getSeconds()
                        ).getTime() + defaultDuration * 60 * 1000
                    );

                    var endNextDay = new Date(endDate.getTime() + 24 * 60 * 60 * 1000);

                    if (newEndDate.getTime() < endNextDay.getTime()) {
                        if (newEndDate.getTime() < realStartTime.getTime()) {
                            endDate = new Date(newEndDate.getTime() + 24 * 60 * 60 * 1000);
                            $endDate.datepicker('update', endDate);
                        } else {
                            endTime = newEndDate;
                            $endTime.timepicker('setTime', endTime);
                        }
                    } else {
                        endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
                        $endDate.datepicker('update', endDate);
                    }
                }
            }

            var deltaDays = endDate.getTime() - startDate.getTime(),
                minTime = new Date(realStartTime.getTime()),
                maxTime = new Date(realStartTime.getTime() + ((24 * 60 * 60) - (15 * 60) * 1000));

            if (deltaDays < 1) {
                $endTime.timepicker('option', {
                    showDuration: true,
                    minTime: minTime,
                    maxTime: maxTime
                });
            } else {
                $endTime.timepicker('option', {
                    showDuration: false,
                    minTime: '00:00',
                    maxTime: '23:59'
                });
            }

            var effectiveStartDate = new Date(
                startDate.getFullYear(), startDate.getMonth(), startDate.getDate(),
                startTime.getHours(), startTime.getMinutes(), startTime.getSeconds()
            );

            var effectiveEndDate = new Date(
                endDate.getFullYear(), endDate.getMonth(), endDate.getDate(),
                endTime.getHours(), endTime.getMinutes(), endTime.getSeconds()
            );

            var periodDuration = (effectiveEndDate.getTime() - effectiveStartDate.getTime()) / 1000 / 60;

            if (periodDuration > 0 && periodDuration < DEFAULT_DURATION * 2) {
                $formEntry.data('period-duration', periodDuration);
            }

            $formEntry.data('period-picker.state', null);
        },

        onControlDateFocus: function(ev) {
            var $this = $(this),
                $formEntry = $this.closest('[data-form-booking-date]'),
                $startDate = $formEntry.find('[data-form-control="start_date"]'),
                $startTime = $formEntry.find('[data-form-control="start_time"]'),
                $endDate = $formEntry.find('[data-form-control="end_date"]'),
                $endTime = $formEntry.find('[data-form-control="end_time"]'),
                defaultDatePeriod = $formEntry.data('default-date-period'),
                $bookingType = $('[data-form-field="booking-type"] input:checked'),
                startDate, endDate;

            if (! ($startDate.val() && $startTime.val() && $endDate.val() && $endTime.val())) {

                if ($startDate.datepicker('getDate')) {
                    startDate = $startDate.datepicker('getDate');
                    endDate = new Date(startDate.getTime() + DEFAULT_DURATION * 60 * 1000);
                } else {
                    var defaultStartDate = defaultDatePeriod.default ? defaultDatePeriod.default.start : defaultDatePeriod.startDate;
                    var defaultEndDate = defaultDatePeriod.default ? defaultDatePeriod.default.end : defaultDatePeriod.endDate;

                    if ($bookingType.length && defaultDatePeriod[$bookingType.val()]) {
                        var bookingTypeId = $bookingType.val();
                        defaultStartDate = defaultDatePeriod[bookingTypeId].start;
                        defaultEndDate = defaultDatePeriod[bookingTypeId].end;
                    }

                    startDate = new Date(defaultStartDate);
                    endDate = new Date(defaultEndDate);
                }

                $startDate.datepicker('update', new Date(
                    startDate.getFullYear(),
                    startDate.getMonth(),
                    startDate.getDate()
                ));

                $startTime.timepicker('setTime', startDate);

                $endDate.datepicker('update', new Date(
                    endDate.getFullYear(),
                    endDate.getMonth(),
                    endDate.getDate()
                ));

                $endTime.timepicker('setTime', endDate);

                $formEntry.trigger('periodpicker.refresh');
            }
        },

        onControlDateChange: function(ev) {
            var $this = $(this),
                $formEntry = $this.closest('[data-form-booking-date]');

            $formEntry.trigger('periodpicker.refresh');

            $formEntry.trigger('bookingdate.autosubmit');
        },

        onControlPendingChange: function(ev) {
            var $pending = $(this),
                $formEntry = $pending.closest('[data-form-booking-date]');

            $formEntry.trigger('bookingdate.autosubmit');
        },

        onControlLockedChange: function(ev) {
            var $locked = $(this),
                $formEntry = $locked.closest('[data-form-booking-date]');

            $formEntry.trigger('bookingdate.autosubmit');
        },

        onControlAllDayRefresh: function(ev) {
            var $allDay = $(this),
                $formEntry = $allDay.closest('[data-form-booking-date]');

            if ($allDay.prop('checked')) {
                $formEntry.addClass('all-day');
                $formEntry.find('[data-form-control="start_time"],[data-form-control="end_time"]')
                    .closest('[gr-grid]').addClass('hidden');
            } else {
                $formEntry.removeClass('all-day');
                $formEntry.find('[data-form-control="start_time"],[data-form-control="end_time"]')
                    .closest('[gr-grid]').removeClass('hidden');
            }
        },

        onControlAllDayChange: function(ev) {
            var $allDay = $(this),
                $formEntry = $allDay.closest('[data-form-booking-date]');

            $allDay.trigger('refresh');
            $formEntry.trigger('bookingdate.autosubmit');
        },

        onControlRepeatsRefresh: function(ev) {
            var $repeats = $(this),
                $formEntry = $repeats.closest('[data-form-booking-date]'),
                $excludeDays = $formEntry.find('[data-form-control="exclude_days"]');

            $excludeDays.trigger('refresh');

            if ($repeats.prop('checked')) {
                $formEntry.addClass('repeats');
                $formEntry.find('[data-repeats-controls]').removeClass('hidden');
            } else {
                $formEntry.removeClass('repeats');
                $formEntry.find('[data-repeats-controls]').addClass('hidden');
            }
        },

        onControlRepeatsChange: function(ev) {
            var $repeats = $(this),
                $formEntry = $repeats.closest('[data-form-booking-date]');

            $repeats.trigger('refresh');

            $formEntry.trigger('bookingdate.autosubmit');
        },

        onControlDefaultRepeatInputChange: function(ev) {
            var $endRepeat = $(this),
                $formEntry = $endRepeat.closest('[data-form-booking-date]');

            $formEntry.trigger('bookingdate.autosubmit');
        },


        onControlFreqRefresh: function(ev) {
            var $freq = $(this),
                $formEntry = $freq.closest('[data-form-booking-date]'),
                $byDayField = $formEntry.find('[data-form-field="by_day"]');

            $byDayField.addClass('hidden');

            if ($freq.val() === 'WEEKLY') {
                $byDayField.removeClass('hidden');
            }
        },

        onControlFreqChange: function(ev) {
            var $freq = $(this),
                $formEntry = $freq.closest('[data-form-booking-date]');

            $freq.trigger('refresh');

            $formEntry.trigger('bookingdate.autosubmit');
        },

        onControlEndRepeatRefresh: function(ev) {
            var $endRepeat = $(this),
                $formEntry = $endRepeat.closest('[data-form-booking-date]'),
                $countField = $formEntry.find('[data-form-field="count"]'),
                $untilField = $formEntry.find('[data-form-field="until"]'),
                $count = $formEntry.find('[data-form-control="count"]'),
                $until = $formEntry.find('[data-form-control="until"]');

            $countField.addClass('hidden');
            $untilField.addClass('hidden');

            if ($endRepeat.val() === 'count') {
                $countField.removeClass('hidden');
            } else if ($endRepeat.val() === 'until') {
                $untilField.removeClass('hidden');
            }
        },

        onControlEndRepeatChange: function(ev) {
            var $endRepeat = $(this),
                $formEntry = $endRepeat.closest('[data-form-booking-date]');

            $endRepeat.trigger('refresh');

            if ($endRepeat.val() === 'never') {
                $formEntry.trigger('bookingdate.autosubmit');
            }
        },

        onControlExcludeDaysRefresh: function(ev) {
            var $excludeDaysInput = $(this),
                $form = $excludeDaysInput.closest('form'),
                $excludeDaysButton = $form.find('[data-form-target-container="exclude_days"]'),
                $excludeDaysField = $excludeDaysInput.closest('[data-form-field="exclude_days"]'),
                $repeatsInput = $form.find('[data-form-control="repeats"]');

            if (! $repeatsInput.prop('checked') || $excludeDaysInput.val() === '') {
                $excludeDaysField.addClass('hidden');
                $excludeDaysButton.removeClass('hidden');
            } else {
                $excludeDaysField.removeClass('hidden');
                $excludeDaysButton.addClass('hidden');
            }
        },

        onBookingDateAutoSubmit: function(ev) {
            var $this = $(this),
                $formEntry = $this.closest('[data-form-booking-date]'),
                $form = $formEntry.closest('form'),
                $startDate = $formEntry.find('[data-form-control="start_date"]'),
                $startTime = $formEntry.find('[data-form-control="start_time"]'),
                $endDate = $formEntry.find('[data-form-control="end_date"]'),
                $endTime = $formEntry.find('[data-form-control="end_time"]');

            if (! ($startDate.val() && $startTime.val() && $endDate.val() && $endTime.val())) {
                return;
            }

            if ($form.is('[data-form-manualsubmit]')) {
                $form.trigger('submit');
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formEntry = $container.find('[data-form-booking-date]');

        $formEntry.find([
            '[data-form-control="start_date"]', '[data-form-control="start_time"]',
            '[data-form-control="end_date"]', '[data-form-control="end_time"]'
        ].join(','))
            .on('focus', _events.onControlDateFocus)
            .on('change', _events.onControlDateChange);

        $formEntry.on('periodpicker.refresh', _events.onPeriodPickerRefresh)
            .trigger('periodpicker.refresh');

        $formEntry.find('[data-form-control="pending"]')
            .on('change', _events.onControlPendingChange);

        $formEntry.find('[data-form-control="locked"]')
            .on('change', _events.onControlLockedChange);

        $formEntry.find('[data-form-control="all_day"]')
            .on('refresh', _events.onControlAllDayRefresh).trigger('refresh')
            .on('change', _events.onControlAllDayChange);

        $formEntry.find('[data-form-control="repeats"]')
            .on('refresh', _events.onControlRepeatsRefresh).trigger('refresh')
            .on('change', _events.onControlRepeatsChange);

        $formEntry.find('[data-form-control="freq"]')
            .on('refresh', _events.onControlFreqRefresh).trigger('refresh')
            .on('change', _events.onControlFreqChange);

        $formEntry.find('[data-form-control="end_repeat"]')
            .on('refresh', _events.onControlEndRepeatRefresh).trigger('refresh')
            .on('change', _events.onControlEndRepeatChange);

        $formEntry.find('[data-form-control="exclude_days"]')
            .on('refresh', _events.onControlExcludeDaysRefresh).trigger('refresh')
            .on('change', _events.onControlDefaultRepeatInputChange);

        $formEntry.find([
            '[data-form-control="interval"]', '[data-form-control="by_day"]',
            '[data-form-control="count"]', '[data-form-control="until"]'
        ].join(',')).on('change', _events.onControlDefaultRepeatInputChange);

        $formEntry.on('bookingdate.autosubmit', _events.onBookingDateAutoSubmit);
    });

} ( require('jquery') ) );
